<div class="sucess">
<img src="../../../assets/images/ic_tick2_lg.svg">    
<p class="mt-3"> 
    {{languageCheck == 2 ? 'Payment successfully done' :  
                       languageCheck == 1 ? 'Pago realizado exitosamente' : 'Pago realizado exitosamente'}}
</p>
</div>
